import React, { forwardRef } from "react";
import styled, { useTheme } from "styled-components";
import { Select } from "antd";
import IconV2 from "../Icon";

const StyledSelect = styled(Select)`
  color: ${props => props.theme.textLight} !important;
  font-size: ${props => props.theme.p3b.fs};
  font-family: ${props => props.theme.p3b.ff};
  min-width: ${({ width }) => width || "250px"};
  height: 36px;
  ${props => props.styles && props.styles}

  .ant-select-selection__rendered {
    padding-right: 15px;
  }

  .ant-select-selection.ant-select-selection.ant-select-selection--single {
    background-color: ${({ isSubscription, theme }) =>
      isSubscription ? theme.textLight : theme.backgroundTag};
    color: ${({ isSubscription, theme }) =>
      isSubscription ? theme.subscribe : theme.textLight};
  }

  & .ant-select-selection-selected-value {
    margin-top: 1.5px;
  }

  ${props =>
    props.noTopMargin &&
    `
  .ant-select-selection--single {
    margin-top: 0;
  }
  `}
`;

const ProjectSelectComponent = forwardRef((props, ref) => {
  const theme = useTheme();
  return (
    <StyledSelect
      ref={ref}
      suffixIcon={
        <IconV2 type="caret_down" size="xxs" color={theme.textLight} />
      }
      {...props}
    />
  );
});

ProjectSelectComponent.Option = Select.Option;

export const ProjectSelect = ProjectSelectComponent;
